module.exports = __webpack_public_path__ + "site/img/18.799a4bbe.jpg";